export default __webpack_public_path__ + "static/media/lucas.66a9c036.jpg";